/* Lubosch Land motion (GSAP + ScrollTrigger, loaded with defer from snippets/ll-head.liquid).
   Colour blocks unroll like labels, photos wipe open, arc text turns with the scroll, fruit drifts.
   Content is visible by default; nothing animates with prefers-reduced-motion. */
(function () {
  var mm;
  function init() {
    if (!window.gsap || !window.ScrollTrigger) return;
    var gsap = window.gsap; gsap.registerPlugin(window.ScrollTrigger);
    if (mm) mm.revert();
    mm = gsap.matchMedia();
    mm.add({ motion: '(prefers-reduced-motion: no-preference)', wide: '(min-width: 861px)' }, function (ctx) {
      if (!ctx.conditions.motion) return;
      var ease = 'expo.out';
      // If GSAP arrives late (slow connection), leave what is already on screen alone: no flash out and back in.
      var late = performance.now() > 1200;
      var inView = function (el) { var r = el.getBoundingClientRect(); return r.top < innerHeight && r.bottom > 0; };
      var skip = function (el) { return late && inView(el); };
      gsap.utils.toArray('[data-ll="label"]').forEach(function (label) {
        if (skip(label)) return;
        gsap.from(label, { y: -40, rotate: -9, opacity: 0, duration: 1.2, ease: ease, delay: .1 });
        gsap.from(label.querySelectorAll(':scope > :not(.ll-stamp):not(.ll-fruit)'), { y: 18, opacity: 0, duration: .9, ease: ease, stagger: .06, delay: .35 });
        gsap.from(label.querySelectorAll('.ll-stamp'), { scale: .4, rotate: -90, opacity: 0, duration: 1.4, ease: 'back.out(1.6)', delay: .6 });
      });
      gsap.utils.toArray('[data-ll="block"]').forEach(function (b) {
        if (skip(b)) return;
        var flip = b.matches(':nth-of-type(even)');
        var copy = b.querySelector('.ll-block__copy'), shot = b.querySelector('.ll-block__shot');
        var tl = gsap.timeline({ scrollTrigger: { trigger: b, start: 'top 82%', once: true } });
        tl.from(copy, { clipPath: flip ? 'inset(0 0 0 100%)' : 'inset(0 100% 0 0)', duration: 1.1, ease: ease })
          .from(copy.children, { y: 24, opacity: 0, stagger: .07, duration: .8, ease: ease }, '-=.7');
        if (shot) {
          tl.from(shot, { clipPath: flip ? 'inset(0 100% 0 0)' : 'inset(0 0 0 100%)', duration: 1.1, ease: ease }, '-=1');
          var img = shot.querySelector('img'); if (img) tl.from(img, { scale: 1.18, duration: 1.6, ease: ease }, '<');
        }
      });
      gsap.utils.toArray('[data-ll="reveal"]').forEach(function (el) {
        if (skip(el)) return;
        // Cards animate themselves (batch below); animating them here too left them stuck at opacity 0.
        var kids = [].filter.call(el.children, function (c) { return c.getAttribute('data-ll') !== 'card'; });
        if (!kids.length) return;
        gsap.from(kids, { y: 26, opacity: 0, stagger: .08, duration: .9, ease: ease, scrollTrigger: { trigger: el, start: 'top 85%', once: true } });
      });
      var cards = gsap.utils.toArray('[data-ll="card"]').filter(function (el) { return !skip(el); });
      if (cards.length) ScrollTrigger.batch(cards, { start: 'top 88%', once: true,
        onEnter: function (els) { gsap.from(els, { y: 40, opacity: 0, rotate: function (i) { return i % 2 ? 1.5 : -1.5; }, stagger: .08, duration: .9, ease: ease }); } });
      gsap.utils.toArray('.ll-block__shot .ll-arc, [data-ll="spin"]').forEach(function (a) {
        gsap.to(a, { rotate: 140, ease: 'none', scrollTrigger: { trigger: a, start: 'top bottom', end: 'bottom top', scrub: 1 } });
      });
      // Dagplan timeline: line draws from the top once, dots pop in with a stagger. Paste inside the mm.add(...) callback.
      gsap.utils.toArray('[data-ll="timeline"]').forEach(function (tl) {
        if (skip(tl)) return;
        var line = tl.querySelector('.ll-dayplan__line'), dots = tl.querySelectorAll('.ll-dayplan__dot');
        var t = gsap.timeline({ scrollTrigger: { trigger: tl, start: 'top 80%', once: true } });
        var across = tl.classList.contains('ll-dayplan--h') && innerWidth >= 900;
        if (line) t.from(line, across ? { scaleX: 0, transformOrigin: 'left center', duration: 1.4, ease: ease } : { scaleY: 0, transformOrigin: 'top center', duration: 1.4, ease: ease });
        if (dots.length) t.from(dots, { scale: 0, opacity: 0, duration: .6, ease: 'back.out(2)', stagger: .18 }, line ? '<.1' : 0);
      });
      // Page photo: slow parallax inside the frame
      gsap.utils.toArray('[data-ll="parallax"] img').forEach(function (img) {
        gsap.fromTo(img, { yPercent: -6, scale: 1.12 }, { yPercent: 6, scale: 1.12, ease: 'none', scrollTrigger: { trigger: img.parentElement, start: 'top bottom', end: 'bottom top', scrub: 1 } });
      });
      if (ctx.conditions.wide) {
        gsap.utils.toArray('.ll-fruit').forEach(function (f, i) {
          gsap.to(f, { y: i % 2 ? -90 : -150, rotate: i % 2 ? 14 : -10, ease: 'none', scrollTrigger: { trigger: f.parentElement, start: 'top bottom', end: 'bottom top', scrub: 1.2 } });
        });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Theme editor: sections are re-rendered in place
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { if (mm) mm.revert(); });
})();
